import { Middleware } from 'redux'
import { isActionOf } from 'typesafe-actions'
import { push } from 'connected-react-router'
import {
    selectCarline,
    setActiveCarlineGroupIdState,
    setDisplayModeState,
    setSelectedCarlineState,
    setActiveCarlineGroupId,
    setDisplayMode,
    toggleFiltersAreVisible,
    setFiltersAreVisibleState,
} from '../../actions/app/carlineSelection.actions'
import { fetchModels } from '../../actions/app/models.actions'
import filtersAreVisibleSelector from '../../selectors/filtersAreVisibleSelector'
import { applyFilter } from '../../actions/app/filter.actions'
import { ROUTE_MODELS } from '../../../constants/routes'

const carlineSelectionMiddleware: Middleware = (store) => (next) => (action) => {
    next(action)
    const { dispatch, getState } = store

    if (isActionOf(selectCarline, action)) {
        dispatch(setSelectedCarlineState(action.payload))
        dispatch(fetchModels(action.payload))

        if (action.meta.forwardToModelPage) {
            dispatch(push(ROUTE_MODELS))
        }
    }

    if (isActionOf(setActiveCarlineGroupId, action)) {
        dispatch(setActiveCarlineGroupIdState(action.payload))
    }

    if (isActionOf(setDisplayMode, action)) {
        dispatch(setDisplayModeState(action.payload))
    }

    if (isActionOf(toggleFiltersAreVisible, action)) {
        const filtersAreVisible = filtersAreVisibleSelector(getState())

        dispatch(setFiltersAreVisibleState(!filtersAreVisible))
    }

    if (isActionOf(applyFilter, action)) {
        const filtersAreVisible = filtersAreVisibleSelector(getState())

        if (!filtersAreVisible) {
            dispatch(setFiltersAreVisibleState(true))
        }
    }
}

export default carlineSelectionMiddleware
